﻿import { loadCart } from "../shoppingcart/cartpopup";
import { getProductDetailImpression, sendDataLayer } from "./ecommerce";

declare const buttonInfoList: any;
declare let buttonImpressionList: any;

const addProductDetailProduct = (src, productID: number) =>
{
    const selector = $(src).closest(".js-article-data")[0];
    const items = getProductDetailImpression(selector);

    sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
    sendDataLayer({
        'event': 'addToCart',
        'ecommerce': {
            'items': [items]
        }
    });

    setTimeout(() =>
    {
        loadCart();
    }, 300);

    if (typeof buttonInfoList !== 'undefined' && buttonInfoList && productID in buttonInfoList)
    {
        sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
        sendDataLayer({
            'event': 'promotionClick',
            'ecommerce': {
                'items': [buttonInfoList[productID]]
            }
        });
    }

}

(window as any).addProductDetailProduct = addProductDetailProduct;

export const sendProductDetailView = () =>
{
    const items = getProductDetailImpression();
    sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
    sendDataLayer({
        'event': 'viewProductPage',
        'ecommerce': {
            'items': [items]
        }
    });

    if (typeof buttonImpressionList !== "undefined")
    {
        window.addEventListener('load', function ()
        {
            sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
            sendDataLayer({
                'ecommerce': {
                    'promoView': {
                        'promotions': buttonImpressionList
                    }
                }
            });
            buttonImpressionList = null;
        });
    }
}

if (!(window as any).sendProductDetailView)
{
    (window as any).sendProductDetailView = sendProductDetailView;
    document.addEventListener("DOMContentLoaded", () =>
    {
        if ($(".c-product-detail__content").length > 0)
        {
            sendProductDetailView();
        }
    });
}
